import {
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Box,
  Button,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import Brightness4Icon from "@mui/icons-material/Brightness4";
import Brightness7Icon from "@mui/icons-material/Brightness7";
import RestaurantMenuIcon from "@mui/icons-material/RestaurantMenu";
import { useTranslation } from "react-i18next";
import { useThemeMode } from "@context/ThemeContext";
import { NAV_DESKTOP_UP } from "./constants";

interface TopBarProps {
  onMenuClick: () => void;
}

export function TopBar({ onMenuClick }: TopBarProps) {
  const { mode, toggleTheme } = useThemeMode();
  const { t, i18n } = useTranslation();

  const toggleLang = () => {
    i18n.changeLanguage(i18n.language === "en" ? "hr" : "en");
  };

  return (
    <AppBar
      position="fixed"
      color="inherit"
      elevation={0}
      sx={{
        display: { xs: "flex", [NAV_DESKTOP_UP]: "none" },
        borderBottom: "1px solid",
        borderColor: "divider",
        zIndex: (theme) => theme.zIndex.drawer + 1,
        pt: "env(safe-area-inset-top, 0px)",
      }}
    >
      <Toolbar sx={{ gap: 0.5, px: { xs: 1, sm: 2 }, minHeight: 56 }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
            flex: 1,
            minWidth: 0,
          }}
        >
          <RestaurantMenuIcon color="primary" sx={{ flexShrink: 0 }} />
          <Typography
            variant="h6"
            noWrap
            sx={{
              fontWeight: "bold",
            }}
          >
            {t("app.name")}
          </Typography>
        </Box>
        <Button
          size="small"
          onClick={toggleLang}
          sx={{ minWidth: 40, flexShrink: 0 }}
        >
          {i18n.language.toUpperCase()}
        </Button>
        <IconButton onClick={toggleTheme} size="small" sx={{ flexShrink: 0 }}>
          {mode === "dark" ? <Brightness7Icon /> : <Brightness4Icon />}
        </IconButton>
        <IconButton edge="end" onClick={onMenuClick} sx={{ flexShrink: 0 }}>
          <MenuIcon />
        </IconButton>
      </Toolbar>
    </AppBar>
  );
}
